import { useTheme } from "@emotion/react";
import {
  Button,
  Chip,
  Divider,
  Grid,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import useStyles from "./styles";
import dayjs from "dayjs";
import {
  Add,
  CheckOutlined,
  ClearOutlined,
  DateRangeOutlined,
  EditOutlined,
  ErrorOutlineOutlined,
  EventRepeatOutlined,
  ManageAccounts,
  ManageHistoryOutlined,
  MoreVertOutlined,
  PersonPinCircleOutlined,
  SupportAgentOutlined,
  TroubleshootOutlined,
  TurnSlightRightOutlined,
} from "@mui/icons-material";
import { maskCpfCnpj, maskPhone } from "../../../utils/masks";
import { useEffect, useState } from "react";

import { LoadingButton } from "@mui/lab";
import EditTicketComponentIxc from "../editTicketComponentIxc";

import api from "../../../services/api";
import CopyButton from "../shared/copyButton";
import InfoField from "../shared/infoField";
export default function OrdemServiceIxcComponent(params) {
  const {
    ticketDetails,
    isEdit = false,
    setOpenNewOs = () => {},
    setOpenEditOS = () => {},
    openEditOS = false,
    setTicketDetails = () => {},
    setIsEditTicket = () => {},
    setEditedTicket = () => {},
    setSnackbar = () => {},
    openNewOs = false,
  } = params;
  const theme = useTheme();
  const styles = useStyles(theme);

  const [paramsEditOs, setParamsEditOs] = useState(null);

  const [horarios, setHorarios] = useState([]);
  const [prioridades, setPrioridades] = useState([]);
  const [prioridadesOs, setPrioridadesOs] = useState([]);
  const [statusOs, setStatusOs] = useState([]);
  const [status, setStatus] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [servicos, setServicos] = useState([]);
  const [loadingParams, setLoadingParams] = useState(false);
  const [loadingCreateTicket, setLoadingCreateTicket] = useState(false);
  const [loadingServicos, setLoadingServicos] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [setores, setSetores] = useState([]);
  const [logins, setLogins] = useState([]);
  const [assuntos, setAssuntos] = useState([]);
  const [filiais, setFiliais] = useState([]);
  const [dataTicket, setDataTicket] = useState({});
  const [loadingLogins, setLoadingLogins] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [error, setError] = useState(false);
  const chipSla = (value) => {
    if (value === 100) {
      return (
        <Chip
          sx={{
            ...styles.chipSla,
            backgroundColor: theme.palette.chip.main.completed,
          }}
          label={`${value}%`}
          size="small"
        />
      );
    } else if (value < 100 && value >= 80) {
      return (
        <Chip
          sx={{
            ...styles.chipSla,
            backgroundColor: theme.palette.colors.yellow.darker,
          }}
          label={`${value}%`}
          size="small"
        />
      );
    } else if (value < 80 && value >= 50) {
      return (
        <Chip
          sx={{
            ...styles.chipSla,
            backgroundColor: theme.palette.chip.main.inProgress,
          }}
          label={`${value}%`}
          size="small"
        />
      );
    } else if (value < 50 && value >= 0) {
      return (
        <Chip
          sx={{
            ...styles.chipSla,
            backgroundColor: theme.palette.chip.main.waitingReturn,
          }}
          label={`${value}%`}
          size="small"
        />
      );
    } else if (value < 0) {
      return (
        <Chip
          sx={{
            ...styles.chipSla,
            backgroundColor: theme.palette.chip.main.pending,
          }}
          label={`${value}%`}
          size="small"
        />
      );
    } else {
      return <Chip sx={{ ...styles.chipSla }} label={""} />;
    }
  };
  const prioridadeConfig = {
    Baixa: (
      <Tooltip title="Prioridade baixa">
        <Chip
          sx={{
            ...styles.chipPriority,
            backgroundColor: theme.palette.colors.blue.medium,
          }}
          size="small"
          label="Baixa"
        />
      </Tooltip>
    ),
    Normal: (
      <Tooltip title="Prioridade normal">
        <Chip
          sx={{
            ...styles.chipPriority,
            backgroundColor: theme.palette.colors.pink.medium,
          }}
          size="small"
          label="Normal"
        />
      </Tooltip>
    ),
    Alta: (
      <Tooltip title="Prioridade alta ">
        <Chip
          sx={{
            ...styles.chipPriority,
            backgroundColor: theme.palette.colors.orange.medium,
          }}
          size="small"
          label="Alta"
        />
      </Tooltip>
    ),
    Crítica: (
      <Tooltip title="Prioridade crítica">
        <Chip
          sx={{
            ...styles.chipPriority,
            backgroundColor: theme.palette.colors.red.medium,
          }}
          size="small"
          label="Crítica"
        />
      </Tooltip>
    ),
  };
  const chipStatus = {
    Aberto: (
      <Tooltip title={"Aberto"}>
        <Chip
          size="small"
          sx={{
            ...styles.chipStatus,
            backgroundColor:
              theme.palette.cardTrafficData.paperColor.outputData,
          }}
          label={
            <Box sx={styles.containerStatusModal}>
              <Typography sx={styles.titleChipModal}>Aberto</Typography>
              <ErrorOutlineOutlined
                sx={{
                  fontSize: "15px",
                  color: theme.palette.white.main,
                }}
              />
            </Box>
          }
        />
      </Tooltip>
    ),
    Encaminhado: (
      <Tooltip title={"Encaminhado"}>
        <Chip
          size="small"
          sx={{
            ...styles.chipStatus,
            backgroundColor: theme.palette.cardTrafficData.paperColor.speeData,
          }}
          label={
            <Box sx={styles.containerStatusModal}>
              <Typography sx={styles.titleChipModal}>Encaminhado</Typography>
              <TurnSlightRightOutlined
                sx={{
                  fontSize: "15px",
                  color: theme.palette.white.main,
                }}
              />
            </Box>
          }
        />
      </Tooltip>
    ),
    Agendado: (
      <Tooltip title={"Agendado"}>
        <Chip
          size="small"
          sx={{
            ...styles.chipStatus,
            backgroundColor: theme.palette.cardTrafficData.paperColor.inputData,
          }}
          label={
            <Box sx={styles.containerStatusModal}>
              <Typography sx={styles.titleChipModal}>Agendado</Typography>
              <DateRangeOutlined
                sx={{
                  fontSize: "15px",
                  color: theme.palette.white.main,
                }}
              />
            </Box>
          }
        />
      </Tooltip>
    ),
    "Em Análise": (
      <Tooltip title={"Em Análise"}>
        <Chip
          size="small"
          sx={{
            ...styles.chipStatus,
            backgroundColor: theme.palette.colors.orange.darker,
          }}
          label={
            <Box sx={styles.containerStatusModal}>
              <Typography sx={styles.titleChipModal}>Em Análise</Typography>
              <TroubleshootOutlined
                sx={{
                  fontSize: "15px",
                  color: theme.palette.white.main,
                }}
              />
            </Box>
          }
        />
      </Tooltip>
    ),
    Assumido: (
      <Tooltip title={"Assumido"}>
        <Chip
          size="small"
          sx={{
            ...styles.chipStatus,
            backgroundColor: theme.palette.colors.blue.dark,
          }}
          label={
            <Box sx={styles.containerStatusModal}>
              <Typography sx={styles.titleChipModal}>Assumido</Typography>
              <SupportAgentOutlined
                sx={{
                  fontSize: "15px",
                  color: theme.palette.white.main,
                }}
              />
            </Box>
          }
        />
      </Tooltip>
    ),
    "Em execução": (
      <Tooltip title={"Em execução"}>
        <Chip
          size="small"
          sx={{
            ...styles.chipStatus,
            backgroundColor: theme.palette.colors.yellow.darker,
          }}
          label={
            <Box sx={styles.containerStatusModal}>
              <Typography sx={styles.titleChipModal}>Em execução</Typography>
              <ManageHistoryOutlined
                sx={{
                  fontSize: "15px",
                  color: theme.palette.white.main,
                }}
              />
            </Box>
          }
        />
      </Tooltip>
    ),
    Finalizado: (
      <Tooltip title={"Finalizado"}>
        <Chip
          size="small"
          sx={{
            ...styles.chipStatus,
            backgroundColor: theme.palette.cardTrafficData.paperColor.statusUp,
          }}
          label={
            <Box sx={styles.containerStatusModal}>
              <Typography sx={styles.titleChipModal}>Finalizado</Typography>
              <CheckOutlined
                sx={{
                  fontSize: "15px",
                  color: theme.palette.white.main,
                }}
              />
            </Box>
          }
        />
      </Tooltip>
    ),
    Deslocamento: (
      <Tooltip title={"Deslocamento"}>
        <Chip
          size="small"
          sx={{
            ...styles.chipStatus,
            backgroundColor: theme.palette.colors.purple.dark,
          }}
          label={
            <Box sx={styles.containerStatusModal}>
              <Typography sx={styles.titleChipModal}>Deslocamento</Typography>
              <PersonPinCircleOutlined
                sx={{
                  fontSize: "15px",
                  color: theme.palette.white.main,
                }}
              />
            </Box>
          }
        />
      </Tooltip>
    ),
    Reagendar: (
      <Tooltip title={"Reagendar"}>
        <Chip
          size="small"
          sx={{
            ...styles.chipStatus,
            backgroundColor: theme.palette.colors.pink.dark,
          }}
          label={
            <Box sx={styles.containerStatusModal}>
              <Typography sx={styles.titleChipModal}>Reagendar</Typography>
              <EventRepeatOutlined
                sx={{
                  fontSize: "15px",
                  color: theme.palette.white.main,
                }}
              />
            </Box>
          }
        />
      </Tooltip>
    ),

    na: (
      <Tooltip title={"N/A"}>
        <Chip
          size="small"
          sx={{
            ...styles.chipStatus,
            backgroundColor: theme.palette.colors.gray.darker,
          }}
          label={
            <Box sx={styles.containerStatusModal}>
              <Typography sx={styles.titleChipModal}>N/A</Typography>
              <ClearOutlined
                sx={{
                  fontSize: "15px",
                  color: theme.palette.white.main,
                }}
              />
            </Box>
          }
        />
      </Tooltip>
    ),
  };
  useEffect(() => {
    if (dataTicket?.clienteServicoId) {
      /*  getInfoClientNewTicket(); */
      getLoginsIxc();
    }
  }, [dataTicket?.clienteServicoId]);

  /*   useEffect(() => {
    if (openNewOs) {
      console.log(ticketDetails?.cliente.idCliente);

      setDataTicket({
        idTicket: ticketDetails?.id_atendimento,
        clienteErpId: ticketDetails?.cliente.idCliente,
      });
    }
  }, [openNewOs]); */
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditOS = () => {
    setOpenEditOS(true);
    setAnchorEl(null);
    getClientes();
    getServicos();
    getParamsEditTicket();
  };

  const handleNewOS = () => {
    setDataTicket({
      idTicket: ticketDetails?.id_atendimento,
      clienteErpId: ticketDetails?.cliente.idCliente,
      nome: ticketDetails?.cliente?.nome || null,
    });
    setOpenNewOs(true);
    setAnchorEl(null);
    getClientes();
    getServicos();
    getParamsEditTicket();
  };
  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);

    setDataTicket({
      id: item?.id_atendimento,
      idTicket: ticketDetails?.id_atendimento,
      clienteErpId: item?.cliente?.idCliente,
      nome: item?.cliente?.nome || null,
      clienteServicoId: item?.clienteServicoId,
      loginId: item?.loginId,
      filialId: item?.filial?.id,
      origem_endereco: item?.origemEndereco,
      assuntoId: item?.id_assunto,
      titulo: item?.assunto,
      departamentoId: item?.setorId,
      prioridadeId: item?.prioridadeId,
      horarioId: item?.horario,
      descricaoAbertura: item?.descricao_abertura,
      responsavelId: item?.tecnicoId || item?.tecnico_id,
      statusId: item?.status?.id,
      protocolo: item?.protocolo,
      endereco: item?.cliente?.endereco_instalacao,
    });
  };
  const closeEditOs = () => {
    setOpenEditOS(false);

    setParamsEditOs(null);
    setError(false);
  };

  const closeNewOs = () => {
    setOpenNewOs(false);

    setParamsEditOs(null);
    setError(false);
  };
  const getServicos = async () => {
    try {
      setLoadingServicos(true);
      const response = await api.post("/interno/find/allServiceClient", {
        idClienteErp: ticketDetails?.cliente.idCliente?.toString(),
      });
      setServicos(response?.data);
    } catch (error) {
      console.error("Erro ao buscar serviços:", error);
    } finally {
      setLoadingServicos(false);
    }
  };
  const getParamsEditTicket = async () => {
    setLoadingParams(true);
    try {
      const response = await api.get("/interno/find/paramsNewTicket");

      setFiliais(response?.data?.filiais || []);
      setAssuntos(response?.data?.assuntos || []);
      setDepartamentos(response?.data?.departamentos || []);
      setSetores(response?.data?.setores || []);
      setPrioridades(response?.data?.prioridades || []);
      setPrioridadesOs(response?.data?.prioridadesOsIxc || []);
      setStatus(response?.data?.status || []);
      setStatusOs(response?.data?.statusOsIxc || []);
      setHorarios(response?.data?.horarios || []);

      /*       setDataTicket({
        clienteErpId: ticketDetails?.cliente?.codigo_cliente,
        nome: ticketDetails?.cliente?.nome || null,
        clienteServicoId: ticketDetails?.clienteServicoId,
        loginId: ticketDetails?.loginId,
        filialId: ticketDetails?.filial?.id,
        origem_endereco: ticketDetails?.origemEndereco,
        assuntoId: ticketDetails?.id_assunto,
        titulo: ticketDetails?.assunto,
        departamentoId: ticketDetails?.setorId,
        prioridadeId: ticketDetails?.prioridadeId,
        horarioId: ticketDetails?.horario,
        descricaoAbertura: ticketDetails?.descricao_abertura,
        responsavelId: ticketDetails?.id_usuario_abertura,
        statusId: ticketDetails?.status?.id,
        protocolo: ticketDetails?.protocolo,
        endereco: ticketDetails?.cliente?.endereco_instalacao,
      }); */
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
    } finally {
      setLoadingParams(false);
    }
  };
  const createOs = async () => {
    if (
      !dataTicket?.clienteErpId ||
      !dataTicket?.clienteServicoId ||
      !dataTicket?.filialId ||
      !dataTicket?.endereco ||
      !dataTicket?.assuntoId ||
      !dataTicket?.departamentoId ||
      !dataTicket?.prioridadeId ||
      !dataTicket?.descricaoAbertura?.trim() ||
      !dataTicket?.statusId ||
      !dataTicket?.responsavelId
    ) {
      setSnackbar({
        severity: "warning",
        children: "Preencha todos os campos obrigatórios",
      });
      setError(true);
      return;
    }

    setLoadingCreateTicket(true);
    try {
      const response = await api.post("/interno/create/os", {
        dataOs: dataTicket,
        idAtendimento: ticketDetails?.id_atendimento,
      });
      setTicketDetails((prev) => {
        return {
          ...prev,

          ordem_servico: [...(prev.ordem_servico || []), response?.data],
        };
      });
      setSnackbar({
        severity: "success",
        children: "OS criada com sucesso",
      });
    } catch (error) {
      console.error("Erro ao criar OS:", error);
      setSnackbar({
        severity: "error",
        children: "Erro ao criar OS",
      });
    } finally {
      setLoadingCreateTicket(false);
      closeNewOs();
    }
  };
  const editOs = async () => {
    if (
      !dataTicket?.clienteErpId ||
      !dataTicket?.clienteServicoId ||
      !dataTicket?.filialId ||
      !dataTicket?.endereco ||
      !dataTicket?.assuntoId ||
      !dataTicket?.departamentoId ||
      !dataTicket?.prioridadeId ||
      !dataTicket?.descricaoAbertura?.trim() ||
      !dataTicket?.statusId ||
      !dataTicket?.responsavelId
    ) {
      setSnackbar({
        severity: "warning",
        children: "Preencha todos os campos obrigatórios",
      });
      setError(true);
      return;
    }

    setLoadingCreateTicket(true);
    try {
      const response = await api.post("/interno/edit/os", {
        idOs: dataTicket?.id,
        dataOs: dataTicket,
      });

      setTicketDetails((prev) => {
        return {
          ...prev,
          ordem_servico: prev?.ordem_servico?.map((os) => {
            if (os?.id_atendimento === response?.data?.id_atendimento) {
              return response?.data;
            }
            return os;
          }),
        };
      });
      setSnackbar({
        severity: "success",
        children: "OS editada",
      });
      setIsEditTicket(false);
      setEditedTicket(true);
      closeEditOs();
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Error: Ocorreu um erro ao editar o atendimento",
        severity: "error",
      });
    } finally {
      setLoadingCreateTicket(false);
    }
  };
  function formatDescricao(mensagem) {
    return (
      <Box sx={{ padding: 2 }}>
        {mensagem?.split("\n\n")?.map((paragraph, index) => (
          <Typography
            key={index}
            sx={{
              fontSize: "0.9375rem",
              lineHeight: 1.6,
              whiteSpace: "pre-wrap", // mantém quebras de linha originais
              overflowWrap: "break-word", // quebra palavras longas
              wordBreak: "break-word", // reforça quebra em palavras muito longas
            }}
          >
            {paragraph}
          </Typography>
        ))}
      </Box>
    );
  }
  const getLoginsIxc = async () => {
    setLoadingLogins(true);
    try {
      const response = await api.post("/interno/find/loginsIxc", {
        idContrato: dataTicket?.clienteServicoId,
      });
      setLogins(response?.data);
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
    } finally {
      setLoadingLogins(false);
    }
  };

  const getClientes = async () => {
    try {
      const response = await api.get("/interno/getClients");
      // Grupos econômicos não podem abrir OS — exclui das options
      setClientes(
        Array.isArray(response?.data)
          ? response.data.filter((cliente) => !cliente?.isGrupoEconomico)
          : [],
      );
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
    } finally {
    }
  };

  return (
    <Box sx={{ height: "80%", overflowY: "auto" }}>
      {openNewOs ? (
        <Box>
          <Box sx={styles.boxEdit}>
            <Typography sx={styles.titleDescription}>
              <ManageAccounts sx={{ fontSize: "18px" }} />
              Nova OS
            </Typography>
          </Box>

          <Box sx={{ ...styles.containerBodyModal, height: "60%" }}>
            <Box sx={styles.boxBodyModal}>
              <EditTicketComponentIxc
                clientes={clientes}
                loadingServicos={loadingServicos}
                loadingCreateTicket={loadingCreateTicket}
                loadingParams={loadingParams}
                setServicos={setServicos}
                servicos={servicos}
                setDataTicket={setDataTicket}
                dataTicket={dataTicket}
                error={error}
                logins={logins}
                filiais={filiais}
                departamentos={departamentos}
                setores={setores}
                assuntos={assuntos}
                status={status}
                statusOs={statusOs}
                prioridades={prioridades}
                prioridadesOs={prioridadesOs}
                horarios={horarios}
                loadingLogins={loadingLogins}
                isOs={true}
                disabledCliente={true}
              />
            </Box>
          </Box>
          <Box sx={styles.containerActions}>
            <Button
              disabled={loadingCreateTicket}
              onClick={() => closeNewOs()}
              size="small"
              variant="outlined"
            >
              Cancelar
            </Button>
            <LoadingButton
              loading={loadingCreateTicket}
              onClick={() => createOs()}
              size="small"
              variant="contained"
            >
              Salvar
            </LoadingButton>
          </Box>
        </Box>
      ) : openEditOS ? (
        <Box>
          <Box sx={styles.boxEdit}>
            <Typography sx={styles.titleDescription}>
              <ManageAccounts sx={{ fontSize: "18px" }} />
              Editar OS - (Número OS: {dataTicket?.protocolo})
            </Typography>
          </Box>
          <Box sx={{ ...styles.containerBodyModal, height: "60%" }}>
            <Box sx={styles.boxBodyModal}>
              <EditTicketComponentIxc
                clientes={clientes}
                loadingServicos={loadingServicos}
                loadingCreateTicket={loadingCreateTicket}
                loadingParams={loadingParams}
                setServicos={setServicos}
                servicos={servicos}
                setDataTicket={setDataTicket}
                dataTicket={dataTicket}
                error={error}
                logins={logins}
                filiais={filiais}
                departamentos={departamentos}
                setores={setores}
                assuntos={assuntos}
                status={status}
                statusOs={statusOs}
                prioridades={prioridades}
                prioridadesOs={prioridadesOs}
                horarios={horarios}
                loadingLogins={loadingLogins}
                isEdit={true}
                isOs={true}
              />
            </Box>
          </Box>
          <Box sx={styles.containerActions}>
            <Button
              disabled={loadingCreateTicket}
              onClick={() => closeEditOs()}
              size="small"
              variant="outlined"
            >
              Cancelar
            </Button>
            <LoadingButton
              loading={loadingCreateTicket}
              onClick={() => editOs()}
              size="small"
              variant="contained"
            >
              Salvar
            </LoadingButton>
          </Box>
        </Box>
      ) : (
        <Box>
          <Box sx={styles.boxEdit}>
            <Typography sx={styles.titleDescription}>
              <ManageAccounts sx={{ fontSize: "18px" }} />
              Ordem de serviço
            </Typography>
            {ticketDetails?.status?.id !== "C" &&
              ticketDetails?.status?.id !== "S" &&
              ticketDetails?.status?.id !== "F" &&
              isEdit && (
                <Button
                  onClick={() => handleNewOS()}
                  endIcon={<Add />}
                  variant="outlined"
                  size="small"
                >
                  Abrir OS
                </Button>
              )}
          </Box>
          <Box sx={styles.containerBodyModal}>
            <Box sx={styles.boxBodyModal}>
              <Paper
                variant="outlined"
                elevation={0}
                sx={styles.containerPaperModal}
              >
                <Box sx={styles.listaOs}>
                  {ticketDetails?.ordem_servico?.map((ordemService, index) => (
                    <Paper
                      key={ordemService?.protocolo || index}
                      sx={styles.containerPaper}
                      variant="outlined"
                      elevation={0}
                    >
                      {/* Cabeçalho do cartão: no IXC o protocolo é o que
                        identifica a OS, então sai da grade de campos e ganha a
                        primeira linha junto do status. */}
                      <Box sx={styles.cardHeader}>
                        <Box sx={styles.cardHeaderIdentificacao}>
                          <Typography sx={styles.cardNumeroOs}>
                            OS {ordemService?.protocolo}
                          </Typography>
                          <CopyButton
                            value={ordemService?.protocolo}
                            setSnackbar={setSnackbar}
                            title="Copiar protocolo da OS"
                            mensagem="Protocolo da OS copiado!"
                          />
                          {chipStatus[ordemService?.status?.descricao] ||
                            chipStatus["na"]}
                        </Box>

                        {ordemService?.status?.descricao !== "Cancelado" &&
                          ordemService?.status?.descricao !== "Fechado" &&
                          ordemService?.status?.descricao !== "Finalizado" &&
                          isEdit && (
                            <IconButton
                              onClick={(e) => handleClick(e, ordemService)}
                              size="small"
                              sx={styles.cardMenuButton}
                            >
                              <MoreVertOutlined fontSize="small" />
                            </IconButton>
                          )}
                      </Box>

                      <Divider />

                      <Box sx={styles.cardSecao}>
                        <Grid container spacing={{ xs: 1, sm: 1.5 }}>
                          <Grid item xs={12} sm={6} lg={4}>
                            <InfoField
                              label="Nome"
                              value={ordemService?.cliente?.nome}
                              tooltip={ordemService?.cliente?.nome}
                              copyValue={ordemService?.cliente?.nome}
                              setSnackbar={setSnackbar}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <InfoField
                              label="CPF / CNPJ"
                              value={maskCpfCnpj(
                                ordemService?.cliente?.cnpj || "",
                              )}
                              copyValue={maskCpfCnpj(
                                ordemService?.cliente?.cnpj || "",
                              )}
                              setSnackbar={setSnackbar}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <InfoField
                              label="Telefone do contato"
                              value={maskPhone(
                                ordemService?.cliente?.telefone_primario || "",
                              )}
                              copyValue={maskPhone(
                                ordemService?.cliente?.telefone_primario || "",
                              )}
                              setSnackbar={setSnackbar}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <InfoField
                              label="Endereço"
                              value={ordemService?.cliente?.endereco_instalacao}
                              tooltip={
                                ordemService?.cliente?.endereco_instalacao
                              }
                              copyValue={
                                ordemService?.cliente?.endereco_instalacao
                              }
                              setSnackbar={setSnackbar}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <InfoField
                              label="Assunto"
                              value={ordemService?.tipo_atendimento}
                              tooltip={ordemService?.tipo_atendimento}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <InfoField
                              label="Técnico"
                              value={ordemService?.tecnico}
                              tooltip={ordemService?.tecnico}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <InfoField
                              label="Setor"
                              value={ordemService?.setor}
                              tooltip={ordemService?.setor}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <InfoField
                              label="Data de cadastro"
                              value={
                                ordemService?.data_cadastro
                                  ? dayjs(ordemService?.data_cadastro).format(
                                      "DD/MM/YY HH:mm",
                                    )
                                  : ""
                              }
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <InfoField label="Prioridade">
                              {prioridadeConfig[ordemService?.prioridade] ? (
                                <Box sx={styles.boxChipCampo}>
                                  {prioridadeConfig[ordemService?.prioridade]}
                                </Box>
                              ) : null}
                            </InfoField>
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <InfoField label="SLA">
                              {ordemService?.sla ? (
                                <Box sx={styles.boxChipCampo}>
                                  <Tooltip title={ordemService?.sla}>
                                    {chipSla(ordemService?.sla)}
                                  </Tooltip>
                                </Box>
                              ) : null}
                            </InfoField>
                          </Grid>
                        </Grid>
                      </Box>

                      <Divider />

                      <Box sx={styles.cardSecao}>
                        <Box sx={styles.cardSecaoHeader}>
                          <Typography sx={styles.cardSecaoTitulo}>
                            Descrição de abertura
                          </Typography>
                          {ordemService?.descricao_abertura && (
                            <CopyButton
                              value={ordemService?.descricao_abertura}
                              setSnackbar={setSnackbar}
                              title="Copiar descrição de abertura"
                              mensagem="Descrição de abertura copiada!"
                            />
                          )}
                        </Box>
                        {ordemService?.descricao_abertura ? (
                          formatDescricao(ordemService?.descricao_abertura)
                        ) : (
                          <Typography sx={styles.textoVazio}>
                            Nenhuma descrição informada.
                          </Typography>
                        )}
                      </Box>
                    </Paper>
                  ))}
                </Box>
              </Paper>
            </Box>
          </Box>
        </Box>
      )}
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
      >
        <MenuItem onClick={handleEditOS}>
          <ListItemIcon>
            <EditOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>Editar</ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
}
